var _defs, _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g3, _g4, _path33, _path34, _path35, _path36, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 994,
    zoomAndPan: "magnify",
    viewBox: "0 0 745.5 221.999995",
    height: 296,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64 175 L 151 175 L 151 221.925781 L 64 221.925781 Z M 64 175 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 114 175 L 200 175 L 200 221.925781 L 114 221.925781 Z M 114 175 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64 0.0742188 L 151 0.0742188 L 151 47 L 64 47 Z M 64 0.0742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 114 0.0742188 L 201 0.0742188 L 201 46 L 114 46 Z M 114 0.0742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 261 89 L 745 89 L 745 191 L 261 191 Z M 261 89 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000199, -3.25449, 3.091375, 0.000000000000000189, 132.757239, 214.578264)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500553 0.000185644 L 15.985169 0.000185644 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 81.347207, 192.716394)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499391 -0.000376778 L 16.445418 -0.0000516391 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000202, 3.295692, -3.106604, 0.00000000000000019, 82.5741, 138.562347)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500226 -0.0000383322 L 16.445519 -0.0000383322 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000202, 3.295692, -3.106604, 0.00000000000000019, 181.951401, 138.562347)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500226 -0.000554985 L 16.445519 -0.000554985 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 131.285619, 213.303343)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499355 0.000223645 L 16.445541 -0.000268838 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 81.347207, 140.887601)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499464 -0.000176286 L 16.445491 0.000148853 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 130.933252, 161.474565)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499955 -0.000646961 L 16.445692 0.0000239736 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 81.596978, 140.879596)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499909 -0.000242647 L 16.445646 0.000428288 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 131.035856, 119.780655)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500406 -0.0000525057 L 16.446433 0.000272634 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000199, -3.25449, 3.091375, 0.000000000000000189, 57.990987, 151.684375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49955 0.000388416 L 15.985366 0.000388416 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 6.580955, 129.822506)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499925 0.000530314 L 16.445525 -0.00031741 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000202, 3.295692, -3.106604, 0.00000000000000019, 7.807854, 75.66847)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500027 -0.000238103 L 16.446505 -0.000238103 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000202, 3.295692, -3.106604, 0.00000000000000019, 107.185161, 75.66847)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500027 0.000504499 L 16.446505 0.000504499 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 56.51937, 150.409467)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499606 0.000104928 L 16.445792 -0.000387555 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 6.580955, 77.993727)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499569 -0.000446378 L 16.445596 -0.000121238 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 56.167001, 98.580698)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499758 0.000395175 L 16.445944 -0.0000973077 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 6.830724, 77.985721)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500162 -0.000361434 L 16.445898 0.000309501 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 56.269604, 56.886778)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500512 -0.000321794 L 16.446539 0.00000334575 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000199, -3.25449, 3.091375, 0.000000000000000189, 210.088028, 151.684375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49955 0.000587382 L 15.985366 0.000587382 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 158.67799, 129.822506)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500101 0.000458191 L 16.445701 -0.000389533 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000202, 3.295692, -3.106604, 0.00000000000000019, 159.904896, 75.66847)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500027 -0.000435785 L 16.446505 -0.000435785 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000202, 3.295692, -3.106604, 0.00000000000000019, 259.282205, 75.66847)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500027 0.00030728 L 16.446505 0.00030728 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 208.616406, 150.409467)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49978 0.000180621 L 16.445966 -0.000311862 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 158.67799, 77.993727)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499745 -0.000518501 L 16.445772 -0.000193362 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 208.264042, 98.580698)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499931 0.000470282 L 16.446117 -0.0000222005 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 158.927753, 77.985721)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500338 -0.000284921 L 16.446074 0.000386014 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 208.366657, 56.886778)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499577 0.0000614943 L 16.445604 0.000386634 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000199, -3.25449, 3.091375, 0.000000000000000189, 132.757239, 103.302399)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499807 0.000185644 L 15.985623 0.000185644 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.060724, 1.164445, -1.167943, 3.069921, 106.499209, 91.525278)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500683 0.000351594 L 8.197546 -0.000180166 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.0000000000000002, 3.269399, -3.284586, 0.000000000000000201, 82.388299, 28.169439)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500168 0.000481016 L 11.896091 0.000481016 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000199, 3.253304, -3.284586, 0.000000000000000201, 181.768214, 27.293309)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500588 -0.000400994 L 12.627684 -0.000400994 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049594, -1.186405, 1.19088, 3.061096, 131.354933, 102.202717)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499781 -0.000130592 L 9.208647 -0.0000604054 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 81.347207, 29.611759)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499727 0.000545935 L 16.445326 -0.000301789 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 130.933252, 50.19872)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499678 0.0000701578 L 16.445864 -0.000422325 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.049355, -1.25021, 1.17848, 2.874399, 81.596978, 29.603749)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499632 0.000474758 L 16.445818 -0.0000177251 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.074113, 1.188031, -1.119868, 2.897737, 131.035856, 8.504808)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500242 -0.000501996 L 16.446269 -0.000176856 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.970305, 1.490084, -1.472809, 2.935871, 80.652333, 114.153642)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49976 0.0000375725 L 9.718807 0.000422448 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.010262, -1.407616, 1.391297, 2.975365, 158.678867, 129.176708)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499921 -0.000119364 L 9.718451 -0.000259189 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.054903, -1.279904, 1.269238, 3.029445, 90.835411, 71.148666)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500222 -0.000203764 L 4.461597 -0.000246922 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(2.986323, 1.510682, -1.482652, 2.930912, 158.720074, 64.902988)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.500675 0.00027519 L 4.736132 0.000277527 ",
    stroke: "#607082",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.177421, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.136719 -28.851562 L 16.136719 -41.320312 L 17.601562 -41.320312 C 22.1875 -41.320312 26.40625 -41.011719 26.40625 -35.085938 C 26.40625 -29.15625 22.1875 -28.851562 17.601562 -28.851562 Z M 16.136719 -21.148438 L 17.601562 -21.148438 C 20.109375 -21.148438 28.054688 -20.84375 28.054688 -14.914062 C 28.054688 -8.984375 22.1875 -8.679688 17.601562 -8.679688 L 16.136719 -8.679688 Z M 34.535156 -25.609375 C 37.164062 -28.054688 38.691406 -31.539062 38.691406 -35.816406 C 38.691406 -45.167969 32.882812 -50.183594 23.042969 -50.183594 L 4.09375 -50.183594 L 4.09375 0 L 23.042969 0 C 32.882812 0 40.339844 -4.828125 40.339844 -14.179688 C 40.339844 -19.253906 38.140625 -23.105469 34.535156 -25.609375 Z M 34.535156 -25.609375 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(318.599221, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.523438 -50.425781 L 4.035156 -50.425781 L 4.035156 0 L 32.882812 0 L 32.882812 -10.085938 L 15.523438 -10.085938 Z M 15.523438 -50.425781 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.505371, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.097656 -25.242188 C 15.097656 -33.066406 21.269531 -39.609375 29.09375 -39.609375 C 36.917969 -39.609375 43.03125 -33.066406 43.03125 -25.242188 C 43.03125 -17.421875 36.917969 -10.820312 29.09375 -10.820312 C 21.269531 -10.820312 15.097656 -17.421875 15.097656 -25.242188 Z M 3.667969 -25.242188 C 3.667969 -11.0625 14.914062 0.917969 29.09375 0.917969 C 43.273438 0.917969 54.460938 -11.0625 54.460938 -25.242188 C 54.460938 -39.425781 43.273438 -51.34375 29.09375 -51.34375 C 14.914062 -51.34375 3.667969 -39.425781 3.667969 -25.242188 Z M 3.667969 -25.242188 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.614217, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 45.292969 -1.527344 L 42.847656 -12.835938 C 42.847656 -12.835938 38.386719 -10.390625 32.515625 -10.390625 C 20.964844 -10.390625 15.890625 -18.460938 15.890625 -25.242188 C 15.890625 -31.96875 20.964844 -40.035156 32.515625 -40.035156 C 38.386719 -40.035156 42.847656 -37.589844 42.847656 -37.589844 L 45.292969 -48.898438 C 45.292969 -48.898438 41.6875 -51.34375 30.746094 -51.34375 C 16.441406 -51.34375 3.421875 -39.609375 3.421875 -25.121094 C 3.421875 -10.695312 16.503906 0.917969 30.746094 0.917969 C 41.6875 0.917969 45.292969 -1.527344 45.292969 -1.527344 Z M 45.292969 -1.527344 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(462.374324, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 49.507812 0 L 28.117188 -25.609375 L 46.332031 -50.425781 L 32.394531 -50.425781 L 15.035156 -25.609375 L 15.035156 -50.425781 L 3.546875 -50.425781 L 3.546875 0 L 15.035156 0 L 15.035156 -25.609375 L 33.617188 0 Z M 49.507812 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.472737, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 45.292969 -1.527344 L 42.847656 -12.835938 C 42.847656 -12.835938 38.386719 -10.390625 32.515625 -10.390625 C 20.964844 -10.390625 15.890625 -18.460938 15.890625 -25.242188 C 15.890625 -31.96875 20.964844 -40.035156 32.515625 -40.035156 C 38.386719 -40.035156 42.847656 -37.589844 42.847656 -37.589844 L 45.292969 -48.898438 C 45.292969 -48.898438 41.6875 -51.34375 30.746094 -51.34375 C 16.441406 -51.34375 3.421875 -39.609375 3.421875 -25.121094 C 3.421875 -10.695312 16.503906 0.917969 30.746094 0.917969 C 41.6875 0.917969 45.292969 -1.527344 45.292969 -1.527344 Z M 45.292969 -1.527344 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.232844, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 40.890625 -50.425781 L 29.398438 -50.425781 L 29.398438 -30.929688 L 16.074219 -30.929688 L 16.074219 -50.425781 L 4.585938 -50.425781 L 4.585938 0 L 16.074219 0 L 16.074219 -19.4375 L 29.398438 -19.4375 L 29.398438 0 L 40.890625 0 Z M 40.890625 -50.425781 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(609.693404, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.679688 -50.425781 L 23.042969 -50.425781 L 2.75 0 L 15.097656 0 L 18.765625 -10.085938 L 37.957031 -10.085938 L 41.746094 0 L 54.09375 0 Z M 34.046875 -20.171875 L 22.675781 -20.171875 L 28.300781 -34.839844 Z M 34.046875 -20.171875 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(666.580199, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.074219 -50.425781 L 4.585938 -50.425781 L 4.585938 0 L 16.074219 0 Z M 16.074219 -50.425781 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#313bac",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(687.232971, 78.011001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.585938 0 L 16.074219 0 L 16.074219 -25.917969 L 47.738281 0 L 47.738281 -50.425781 L 36.246094 -50.425781 L 36.125 -24.449219 L 4.585938 -50.425781 Z M 4.585938 0 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.65914, 0, 0, 1.65914, 274.110012, 95.987673)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.450528 14.705837 L 11.747982 14.705837 L 11.747982 46.000282 L 20.661673 46.000282 L 20.661673 14.705837 L 29.959127 14.705837 L 29.959127 6.879871 L 2.450528 6.879871 Z M 58.063385 6.879871 L 35.684984 6.879871 L 35.684984 46.000282 L 58.063385 46.000282 L 58.063385 38.174317 L 44.598674 38.174317 L 44.598674 30.301263 L 57.495979 30.301263 L 57.495979 22.475297 L 44.598674 22.475297 L 44.598674 14.705837 L 58.063385 14.705837 Z M 96.559885 44.818383 L 94.659899 36.043601 C 94.659899 36.043601 91.198957 37.941233 86.647937 37.941233 C 77.687159 37.941233 73.752987 31.678577 73.752987 26.411824 C 73.752987 21.201577 77.687159 14.938921 86.647937 14.938921 C 91.198957 14.938921 94.659899 16.836553 94.659899 16.836553 L 96.559885 8.061771 C 96.559885 8.061771 93.758171 6.164139 85.270624 6.164139 C 74.17913 6.164139 64.074122 15.273243 64.074122 26.515417 C 64.074122 37.698732 74.226218 46.706597 85.270624 46.706597 C 93.758171 46.706597 96.559885 44.818383 96.559885 44.818383 Z M 130.973887 6.879871 L 122.060197 6.879871 L 122.060197 21.999712 L 111.722105 21.999712 L 111.722105 6.879871 L 102.806061 6.879871 L 102.806061 46.000282 L 111.722105 46.000282 L 111.722105 30.915757 L 122.060197 30.915757 L 122.060197 46.000282 L 130.973887 46.000282 Z M 177.529437 44.818383 L 175.62945 36.043601 C 175.62945 36.043601 172.168509 37.941233 167.619843 37.941233 C 158.659065 37.941233 154.722538 31.678577 154.722538 26.411824 C 154.722538 21.201577 158.659065 14.938921 167.619843 14.938921 C 172.168509 14.938921 175.62945 16.836553 175.62945 16.836553 L 177.529437 8.061771 C 177.529437 8.061771 174.727722 6.164139 166.240175 6.164139 C 155.151036 6.164139 145.043674 15.273243 145.043674 26.515417 C 145.043674 37.698732 155.195769 46.706597 166.240175 46.706597 C 174.727722 46.706597 177.529437 44.818383 177.529437 44.818383 Z M 192.263159 6.879871 L 183.347115 6.879871 L 183.347115 46.000282 L 205.737288 46.000282 L 205.737288 38.174317 L 192.263159 38.174317 Z M 242.717566 6.879871 L 233.792103 6.879871 L 233.792103 29.503128 C 233.792103 36.043601 231.800296 37.941233 227.449398 37.941233 C 223.084374 37.941233 221.092567 36.043601 221.092567 29.503128 L 221.092567 6.879871 L 212.178877 6.879871 L 212.178877 32.107074 C 212.178877 41.774167 217.480945 46.706597 227.449398 46.706597 C 237.403725 46.706597 242.717566 41.774167 242.717566 32.107074 Z M 258.583746 23.621882 L 258.583746 13.943017 L 259.73033 13.943017 C 263.285447 13.943017 266.54862 14.185518 266.54862 18.781272 C 266.54862 23.37938 263.285447 23.621882 259.73033 23.621882 Z M 258.583746 29.594949 L 259.73033 29.594949 C 261.67505 29.594949 267.834113 29.825678 267.834113 34.435558 C 267.834113 39.031312 263.285447 39.262041 259.73033 39.262041 L 258.583746 39.262041 Z M 272.858364 26.134007 C 274.897259 24.234021 276.088576 21.526482 276.088576 18.213866 C 276.088576 10.955306 271.584643 7.065867 263.944674 7.065867 L 249.241558 7.065867 L 249.241558 46.000282 L 263.944674 46.000282 C 271.584643 46.000282 277.362297 42.249752 277.362297 35.00061 C 277.362297 31.066437 275.660079 28.078727 272.858364 26.134007 Z M 272.858364 26.134007 ",
    stroke: "#607082",
    strokeWidth: 1.778389,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.360dcd06eb29216b5c7796f25837a5d0.svg";
export { ForwardRef as ReactComponent };